import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const CheckboxIcon = ({ className }) => (
  /* eslint max-len: ["error", { "ignoreStrings": true }] */
  <SvgIcon viewBox='0 0 30 30' className={className}>
    <g id='Group_1548' data-name='Group 1548' transform='translate(-1177 -222)'>
      <g
        id='Rectangle_70645'
        data-name='Rectangle 70645'
        transform='translate(1177 222)'
        fill='none'
        stroke='#0087ff'
        strokeWidth='3'
      >
        <rect width='30' height='30' rx='4' stroke='none' />
        <rect
          x='1.5'
          y='1.5'
          width='27'
          height='27'
          rx='2.5'
          fill='none'
        />
      </g>
      <path
        id='Path_12559'
        data-name='Path 12559'
        d='M2360.908,1120.384l5.261,5.26,8.275-8.247'
        transform='translate(-1175.489 -884.518)'
        fill='none'
        stroke='#0087ff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </g>
  </SvgIcon>
);

export default CheckboxIcon;
